<style scoped>
    li {
        font-size: 14px
    }
</style>
<template>
    <div>
        <nav class="navbar navbar-default">
            <div class="container">
                <div class="navbar-header">
                    <button class="navbar-toggle collapsed" type="button" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href="#">
                       
                        <span style="color:#6bd6b4; font-size:24px; margin-left:20px">
                           
                            <!--<strong>VCARE </strong>--> 
                            <!--<img height="100%" src="../../Assets/Full512x512.png" />-->
                            <img height="200%" src="../../Assets/Full512x512.png"style="margin-top:-10px" />
                            Pharmacy
                        </span>
                    </a>
                </div>

                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul class="nav navbar-nav">
                        <li>
                            <router-link to="/pharmacy-users">
                                <i class="fa fa-users" aria-hidden="true"></i> Pharmacy Users
                            </router-link>

                        </li>
                        <li>
                            <router-link to="/pharmacy-carehomes">
                                <i class="fa fa-home" aria-hidden="true"></i> Carehomes
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/fmd">
                                <i class="fa fa-home" aria-hidden="true"></i> FMD
                            </router-link>
                        </li>
                    </ul>
                    <ul class="nav navbar-nav navbar-right">
                        <li class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><i class="fa fa-user"></i>       {{$root.$data.UserName}}     <span class="caret"></span></a>
                            <ul class="dropdown-menu" role="menu">
                                <!--<li><a href="signout">Logout</a></li>-->
                                <li><a href="" @click.prevent="Logout()">Logout</a></li>
                                <li><a href="security">Security</a></li>
                                <!--<li v-if="!$root.$data.IsCarehomeUser && $root.$data.Carehomes.length > 0"><a href="#" @click="$root.$data.IsCarehomeUser = true">Carehome Portal</a></li>-->
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
    import GlobalUserManager from '../../boot'
    export default {
        methods: {
            Logout() {
                 this.$root.UserManager.Logout();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PharmacyNavMenu.scp.html?41f09378